export default {
  en: {
    'There is no user record corresponding to this identifier. The user may have been deleted.':
      'Nu exista un utilizator cu aceasta adresa de email',
    students: {
      title: 'Cursanti',
    },
    instructors: {
      title: 'Lectori',
      courses: {
        buttons: {
          end: 'Incheie curs',
          start: 'Incepe curs',
        },
        dialog: {
          buttons: {
            end: 'Incheie curs',
            start: 'Incepe curs',
          },
          title: {
            end: 'Incheiere curs',
            start: 'Incepere curs',
          },
          confirmation: {
            end: 'Sunteti sigur ca doriti sa incheiati cursul?',
            start: 'Sunteti sigur ca doriti sa incepeti cursul?',
          },
        },
        students: {
          confirmed: 'Cursanti confirmati',
          waiting_confirmation: 'Cursanti in curs de confirmare',
        },
        in_progress: 'Cursuri in desfasurare',
        upcoming: 'Cursuri viitoare',
        completed: 'Istoric cursuri',
      },
    },
    account: {
      title: 'My account',
    },
    buttons: {
      cancel: 'Cancel',
    },
    courses: {
      buttons: {
        join: 'Join',
        leave: 'Leave',
      },
      dialog: {
        confirmation: {
          join: 'Join',
          leave: 'Leave',
        },
        title: {
          join: 'Join',
          leave: 'Leave',
        },
      },
      list: {
        name: 'Courses',
        title: 'Courses',
        instructor: 'Lector',
        credits: 'Credits',
        buttons: {
          join: 'Join',
          leave: 'Leave',
        },
      },
      available: {
        title: 'Courses available',
      },
      completed: {
        title: 'Course history',
      },
      upcoming: {
        title: 'My courses',
      },
    },
    aor: {
      action: {
        delete: 'Delete',
        show: 'Show',
        list: 'List',
        save: 'Save',
        create: 'Create',
        edit: 'Edit',
        cancel: 'Cancel',
        refresh: 'Refresh',
        add_filter: 'Add filter',
        remove_filter: 'Remove this filter',
      },
      boolean: {
        true: 'Yes',
        false: 'No',
      },
      page: {
        list: '%{name} List',
        edit: '%{name} #%{id}',
        show: '%{name} #%{id}',
        create: 'Create %{name}',
        delete: 'Delete %{name} #%{id}',
        dashboard: 'Dashboard',
      },
      input: {
        file: {
          upload_several: 'Drop some files to upload, or click to select one.',
          upload_single: 'Drop a file to upload, or click to select it.',
        },
        image: {
          upload_several:
            'Drop some pictures to upload, or click to select one.',
          upload_single: 'Drop a picture to upload, or click to select it.',
        },
      },
      message: {
        yes: 'Yes',
        no: 'No',
        are_you_sure: 'Are you sure ?',
        about: 'About',
      },
      navigation: {
        no_results: 'No results found',
        page_out_of_boundaries: 'Page number %{page} out of boundaries',
        page_out_from_end: 'Cannot go after last page',
        page_out_from_begin: 'Cannot go before page 1',
        page_range_info: '%{offsetBegin}-%{offsetEnd} of %{total}',
        next: 'Next',
        prev: 'Prev',
      },
      auth: {
        username: 'Username',
        password: 'Password',
        sign_in: 'Sign in',
        sign_in_error: 'Authentication failed, please retry',
        logout: 'Logout',
        email: 'Email',
        reset_password: 'Reset password',
        create_account: 'Create account',
        first_name: 'First Name',
        last_name: 'Last Name',
        cnp: 'CNP',
        phone_number: 'Phone Number',
        forgot: 'Forgot password',
      },
      notification: {
        updated: 'Element updated',
        created: 'Element created',
        deleted: 'Element deleted',
        item_doesnt_exist: 'Element does not exist',
        http_error: 'Server communication error',
      },
      validation: {
        required: 'Required',
        minLength: 'Must be %{min} characters at least',
        maxLength: 'Must be %{max} characters or less',
        minValue: 'Must be at least %{min}',
        maxValue: 'Must be %{max} or less',
        number: 'Must be a number',
        email: 'Must be a valid email',
      },
    },
  },
  ro: {
    'There is no user record corresponding to this identifier. The user may have been deleted.':
      'Nu exista un utilizator cu aceasta adresa de email',
    'The password is invalid or the user does not have a password.':
      'Parola este incorecta. Va rugam sa incercati din nou sau sa apasati butonul AM UITAT PAROLA',
    students: {
      title: 'Cursanti',
    },
    instructors: {
      title: 'Lectori',
      courses: {
        buttons: {
          end: 'Incheie curs',
          start: 'Incepe curs',
        },
        dialog: {
          buttons: {
            end: 'Incheie curs',
            start: 'Incepe curs',
          },
          title: {
            end: 'Incheiere curs',
            start: 'Incepere curs',
          },
          confirmation: {
            end: 'Sunteti sigur ca doriti sa incheiati cursul?',
            start: 'Sunteti sigur ca doriti sa incepeti cursul?',
          },
        },
        students: {
          confirmed: 'Cursanti confirmati',
          waiting_confirmation: 'Cursanti in curs de confirmare',
        },
        in_progress: 'Cursuri in desfasurare',
        upcoming: 'Cursuri viitoare',
        completed: 'Istoric cursuri',
      },
    },
    account: {
      title: 'Contul meu',
    },
    buttons: {
      cancel: 'Anuleaza',
    },
    courses: {
      status: {
        in_progress: 'Curs in desfasurare',
        upcoming: 'Curs viitor',
        completed: 'Curs incheiat',
      },
      buttons: {
        join: 'Inscriere',
        leave: 'Parasire',
      },
      dialog: {
        confirmation: {
          join: 'Va rugam confirmati inscrierea la curs',
          leave: 'Va rugam confirmati parasirea acestui curs.',
        },
        title: {
          join: 'Inscriere curs',
          leave: 'Parasire curs',
        },
        buttons: {
          join: 'Inscriere',
          leave: 'Parasire',
        },
      },
      list: {
        name: 'Cursuri',
        title: 'Cursuri',
        instructor: 'Lector',
        credits: 'Credite',
        buttons: {
          join: 'Inscriere',
          leave: 'Parasire',
        },
      },
      available: {
        title: 'Cursuri dipsonibile',
      },
      completed: {
        title: 'Istoric cursuri',
      },
      upcoming: {
        title: 'Cursurile mele',
      },
    },
    aor: {
      action: {
        delete: 'Sterge',
        show: 'Arata',
        list: 'Lista',
        save: 'Salveaza',
        create: 'Creeaza',
        edit: 'Editeaza',
        cancel: 'Anuleaza',
        refresh: 'Reincarca',
        add_filter: 'Adauga filtru',
        remove_filter: 'Scoate filtru',
      },
      boolean: {
        true: 'Da',
        false: 'Nu',
      },
      page: {
        list: '%{name} List',
        edit: '%{name} #%{id}',
        show: '%{name} #%{id}',
        create: 'Creeaza %{name}',
        delete: 'Sterge %{name} #%{id}',
        dashboard: 'Dashboard',
      },
      input: {
        file: {
          upload_several: 'Drop some files to upload, or click to select one.',
          upload_single: 'Drop a file to upload, or click to select it.',
        },
        image: {
          upload_several:
            'Drop some pictures to upload, or click to select one.',
          upload_single: 'Drop a picture to upload, or click to select it.',
        },
      },
      message: {
        yes: 'Da',
        no: 'Nu',
        are_you_sure: 'Sunteti sigur(a) ?',
        about: 'Despre',
      },
      navigation: {
        no_results: 'Nu au fost gasite rezultate',
        page_out_of_boundaries: 'Pagina numarul %{page} nu exista',
        page_out_from_end: 'Ultima pagina',
        page_out_from_begin: 'Sunteti deja la prima pagina',
        page_range_info: '%{offsetBegin}-%{offsetEnd} of %{total}',
        next: 'Urmatoarea',
        prev: 'Precedenta',
      },
      auth: {
        username: 'Nume utilizator',
        password: 'Parola',
        sign_in: 'Accesati cont',
        sign_in_error: 'Utilizatorul nu a putut fi validat',
        logout: 'Iesire din cont',
        email: 'Email',
        reset_password: 'Reseteaza parola',
        create_account: 'Creeaza cont',
        first_name: 'Prenume',
        last_name: 'Nume',
        cnp: 'Cod numeric personal',
        phone_number: 'Numar de telefon',
        forgot: 'Am uitat parola',
        edit_account: 'Modifica',
      },
      notification: {
        updated: 'Elementul a fost updatat cu succes',
        created: 'Elementul a fost creeat',
        deleted: 'Elementul a fost sters',
        item_doesnt_exist: 'Elementul nu exista',
        http_error: 'Probleme la comunicarea cu serverul',
      },
      validation: {
        required: 'Necesar',
        minLength: 'Must be %{min} characters at least',
        maxLength: 'Must be %{max} characters or less',
        minValue: 'Must be at least %{min}',
        maxValue: 'Must be %{max} or less',
        number: 'Must be a number',
        email: 'Must be a valid email',
      },
    },
  },
}



// WEBPACK FOOTER //
// ./src/messages.js